/** NX Auto Care (nxautocare.online) */
export const SITE_NAME = 'NX Auto Care';
export const SITE_SHORT = 'NX Auto';
export const SITE_TAGLINE = 'Reliable Parts. Expert Care.';
/** Legal operator */
export const COMPANY_NAME = 'Nodex Global LLC';
export const SITE_DOMAIN = 'nxautocare.online';
export const SITE_URL = 'https://www.nxautocare.online';
